import * as THREE from 'three';

/** Bake metric UVs once: textures stay attached to moving parts. Floor top UVs
 *  use the same X/Z coordinates across slabs, center fill and every rail insert,
 *  so a narrow insert shows a slice of the floor texture instead of stretching it.
 */
export function applyMetricUVs(root) {
  root.updateWorldMatrix(true, true);
  const point = new THREE.Vector3(), normal = new THREE.Vector3(), normalMatrix = new THREE.Matrix3();
  root.traverse(mesh => {
    if (!mesh.isMesh || !mesh.geometry || mesh.geometry.userData.metricUVs) return;
    const candidates = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
    const material = candidates.find(m => m.userData?.role === 'frame') || candidates.find(m => m.userData?.tileSize);
    if (!material || ['glass', 'glass-edge'].includes(material.userData.role)) return;
    const geometry = mesh.geometry, positions = geometry.attributes.position, normals = geometry.attributes.normal;
    if (!positions || !normals) return;
    geometry.computeBoundingBox();
    const size = geometry.boundingBox.clone().applyMatrix4(mesh.matrixWorld).getSize(new THREE.Vector3()).toArray();
    const tile = material.userData.tileSize, uv = new Float32Array(positions.count * 2);
    const isFloor = material.userData.role.startsWith('floor');
    normalMatrix.getNormalMatrix(mesh.matrixWorld);
    for (let i = 0; i < positions.count; i++) {
      point.fromBufferAttribute(positions, i).applyMatrix4(mesh.matrixWorld);
      normal.fromBufferAttribute(normals, i).applyMatrix3(normalMatrix).normalize();
      const n = [Math.abs(normal.x), Math.abs(normal.y), Math.abs(normal.z)];
      const dominant = n.indexOf(Math.max(...n));
      const axes = [0, 1, 2].filter(axis => axis !== dominant);
      if (!isFloor) axes.sort((a, b) => size[b] - size[a]);
      const coords = point.toArray();
      uv[i * 2] = coords[axes[0]] / tile;
      uv[i * 2 + 1] = coords[axes[1]] / tile;
    }
    geometry.setAttribute('uv', new THREE.BufferAttribute(uv, 2));
    geometry.userData.metricUVs = true;
  });
}

export function addGlassEdges(root, material) {
  const panes = [];
  root.traverse(mesh => { if (mesh.isMesh && mesh.material?.userData?.role === 'glass' && !mesh.userData.glassEdges) panes.push(mesh); });
  panes.forEach(mesh => {
    const outline = new THREE.LineSegments(new THREE.EdgesGeometry(mesh.geometry, 25), material);
    outline.name = 'glass-thickness-edge'; outline.raycast = () => {};
    mesh.add(outline); mesh.userData.glassEdges = true;
    // Clear glass should not throw an opaque rectangular shadow over the rails.
    mesh.castShadow = false;
  });
}